import React, { Component } from 'react';
import axios from 'axios';
import { Form, Header, Message, Segment } from 'semantic-ui-react';
import { toast, ToastContainer } from 'react-toastify';
import { FormattedMessage } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { fetchAcademicYears, fetchAllAcademicYears, fetchMarks } from '../Lookups/util';
import CourseGradingTable from '../Professor/ProfessorInputGrades/CourseGradingTable';
import InfoCircleManualTooltip from '../../components/InfoCircleManualTooltip';

const OTHER_ACTIVITIES_VALUE = 'OTHER_ACTIVITIES';

class ExternalStudentGradingList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            courses: [],
            filteredCourses: [],
            searchResults: [],
            marks: [],
            courseOptions: [],
            selectedCourseId: null,
            searchText: '',
            loading: false,
            error: false,
            academicYears: [],
            selectedAcademicYearId: null,
        };
    }

    componentDidMount() {
        this.setState({ loading: true });
        Promise.all([
            axios.get('/external-student-course/grading'),
            fetchMarks(),
            fetchAcademicYears()
        ])
            .then(([coursesRes, marksRes, academicYearsRes]) => {
                const marks = marksRes.data.map(el => ({
                    key: el.id,
                    value: el.id,
                    text: ((window.$locale !== 'bs' && el.translations.length)
                        ? el.translations.find(e => e.language === window.$locale).displayName
                        : el.displayName),
                }));

                const courseOptions = Array.from(
                    new Map(
                        coursesRes.data
                            .filter(c => !c.isActivity)
                            .map(c => [c.courseBasicId, {
                                key: c.courseBasicId,
                                value: c.courseBasicId,
                                text: c.courseName,
                            }])
                    ).values()
                );

                if (coursesRes.data.some(c => c.isActivity)) {
                    courseOptions.unshift({
                        key: OTHER_ACTIVITIES_VALUE,
                        value: OTHER_ACTIVITIES_VALUE,
                        text: <FormattedMessage id="externalStudent.otherActivityTypes"/>,
                    });
                }

                const sortedAcademicYears = academicYearsRes.data.sort((a, b) => b.startYear - a.startYear);

                this.setState({
                    courses: coursesRes.data,
                    filteredCourses: coursesRes.data,
                    marks,
                    courseOptions,
                    academicYears: sortedAcademicYears,
                    selectedAcademicYearId: sortedAcademicYears.length > 0 ? sortedAcademicYears[0].id : null,
                    loading: false,
                }, this.applyFilters);
            })
            .catch(() => {
                this.setState({
                    loading: false,
                    error: true
                });
            });
    }

    applyFilters = () => {
        const {
            courses,
            searchText,
            searchResults,
            selectedCourseId,
            selectedAcademicYearId
        } = this.state;
        let result = searchText ? searchResults : courses;
        if (selectedAcademicYearId) {
            result = result.filter(c => c.academicYearId === selectedAcademicYearId);
        }
        if (selectedCourseId) {
            if (selectedCourseId === OTHER_ACTIVITIES_VALUE) {
                result = result.filter(c => c.isActivity === true && c.courseStudyProgramId === null);
            } else {
                result = result.filter(c => c.courseBasicId === selectedCourseId);
            }
        }
        this.setState({ filteredCourses: result });
    };

    handleCourseFilterChange = (value) => {
        this.setState({ selectedCourseId: value || null }, this.applyFilters);
    };

    handleSearchTextChange = (value) => {
        this.setState({ searchText: value });
    };

    getSearchResults = (results) => {
        this.setState({ searchResults: results }, this.applyFilters);
    };

    handleSave = (editingRowId, editedRowData) => {
        return axios.put('/external-student-course', {
            id: editingRowId,
            markId: editedRowData.markId || null,
            dateOfExam: editedRowData.dateOfExam ? new Date(editedRowData.dateOfExam) : null,
        })
            .then(() => axios.get('/external-student-course/grading'))
            .then(res => {
                this.setState({ courses: res.data }, this.applyFilters);
                toast(<FormattedMessage id="externalStudent.toast.courseUpdated"/>);
            })
            .catch(() => {
                toast(<FormattedMessage id="externalStudent.toast.saveError"/>);
                throw new Error();
            });
    };

    handleShowDetails = (course) => {
        localStorage.setItem('externalStudentId', course.externalStudentId);
        this.props.history.push('/dolazne-mobilnosti/student');
    };

    render() {
        const {
            courses,
            filteredCourses,
            marks,
            courseOptions,
            selectedCourseId,
            loading,
            academicYears,
            selectedAcademicYearId,
        } = this.state;

        return (
            <div>
                <h2><FormattedMessage id="externalStudent.externalStudents"/></h2>
                <Segment.Group raised>
                    <Segment>
                        <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
                            <Header as="h3" style={{ margin: 0 }}>
                                <FormattedMessage id="sidebar.grading"/>
                            </Header>
                            <InfoCircleManualTooltip/>
                        </div>
                    </Segment>
                    <Segment>
                        <Form>
                            <Form.Group widths="equal">
                                <Form.Select
                                    fluid
                                    label={<FormattedMessage id="externalStudent.academicYear"/>}
                                    placeholder={<FormattedMessage id="externalStudent.selectAcademicYear"/>}
                                    clearable
                                    options={academicYears.map(y => ({
                                        key: y.id,
                                        text: y.name,
                                        value: y.id
                                    }))}
                                    value={selectedAcademicYearId}
                                    onChange={(e, { value }) => this.setState({ selectedAcademicYearId: value || null }, this.applyFilters)}
                                />
                                <Form.Select
                                    fluid
                                    label={<FormattedMessage id="externalStudent.course"/>}
                                    placeholder={<FormattedMessage id="externalStudent.selectCourse"/>}
                                    clearable
                                    options={courseOptions}
                                    value={selectedCourseId}
                                    onChange={(e, { value }) => this.handleCourseFilterChange(value)}
                                />
                            </Form.Group>
                        </Form>
                    </Segment>
                    <Segment>
                        <Message>
                            U prikazanoj tabeli se vrši pregled i unos ocjena za sve strane studente u mobilnosti — kako za
                            studente na cikličnim, tako i za studente na necikličnim programima mobilnosti.
                            Rezultate je moguće filtrirati po akademskoj godini i predmetu. Ako se predmet ne nalazi na
                            popisu, moguće je da se radi o aktivnosti koja nije vezana za predmet (npr. istraživački
                            rad, praksa, itd.) — u tom slučaju odaberite opciju "Ostali tipovi aktivnosti".
                            Klikom na dugme "Profil studenta" moguće je vidjeti detalje o studentu i njegovom programu
                            mobilnosti.
                        </Message>
                        <CourseGradingTable
                            courses={filteredCourses}
                            marks={marks}
                            loading={loading}
                            onSave={this.handleSave}
                            onShowDetails={this.handleShowDetails}
                            allCourses={courses}
                            getResults={this.getSearchResults}
                            onSearchTextChange={this.handleSearchTextChange}
                        />
                    </Segment>
                </Segment.Group>
                <ToastContainer hideProgressBar/>
            </div>
        );
    }
}

export default withRouter(ExternalStudentGradingList);



// WEBPACK FOOTER //
// ./src/views/ExternalStudents/ExternalStudentGradingList.js